import { Typography,Box } from "@mui/material";
import { useState,useEffect } from "react";
import CoursesBlog from "../../../../Blog/courses-blog.component";
import { getCoursesFirstCard } from "../../../../../utils/firebase/firebase.utils";
import { Helmet } from "react-helmet-async";

const CoursesFirstCard = ()=>{

    const [courseData,setCourseData] = useState([]);

    useEffect(()=>{
        const getData = async()=>{
            const arrayData = await getCoursesFirstCard();
            const{data} = arrayData;
            setCourseData(data.reverse());
        
        }

        getData();
        
        
    },[])




    return(
        <>
        <Helmet>
                <title> Regular Classroom Courses | Ahguide  </title>
                <meta name="description" content="Join Classroom Course for WBCS Basic Courses,Prelims,Mains and Personality Test." />        
                <link rel="canonical"  href="https://www.ahguide.in/regular-classroom-course" />
            </Helmet>
        <Box>
            <Typography sx={{textAlign:"center",marginTop:'20px'}} variant="h3" component="div">
                Regular Classroom Courses
            </Typography>
            {
                courseData.map((data)=>{
                    return  <CoursesBlog key={data.title} courseData= {data}  />
                })
            }

        </Box>
        </>
    )

}

export default CoursesFirstCard;